import React from 'react';
import CommonPage from './CommonPage';
import { CONST_REPORT_TABS_NEW_COLUMNS } from '../../common/reportsConstants';
export default function OrderDetail() {
  const tabKey = 'Summary';
  const columnsProp = CONST_REPORT_TABS_NEW_COLUMNS.filter(item => item.key === tabKey)[0].orderDetail.columns;
  const level = CONST_REPORT_TABS_NEW_COLUMNS.filter(item => item.key === tabKey)[0].orderDetail.level;
  return (
    <div className="reports-new-order-detail">
      <CommonPage tabKey={tabKey} columnsProp={columnsProp} level={level} />
    </div>
  );
};

OrderDetail.propTypes = {};
OrderDetail.defaultProps = {};
